import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrustContentModule } from '../../../pipes/trust-content/trust-content.module';
import { IconComponent } from './icon.component';

@NgModule({
  imports: [CommonModule, TrustContentModule],
  declarations: [IconComponent],
  exports: [IconComponent]
})
export class IconModule {}
